import { NotificationOutlined, SettingOutlined } from '@ant-design/icons';
import { Layout, Menu, Skeleton } from 'antd';
import { Link, NavLink } from 'react-router-dom';

import * as S from './styled';
import { useHeader } from './useHeader';

import { useTheme } from '../../../hooks/useTheme';
import { getLiteName } from '../../../utils/getLiteName/getLiteName';
import { getProName } from '../../../utils/getProName/getProName';
import { isIntelbrasTenant } from '../../../utils/isIntelbrasTenant/isIntelbrasTenant';
import { isProUser } from '../../../utils/isProUser/isProUser';
import { parseNotificationsTimeline } from '../../../utils/normalizers/notificationTimeline';
import { Shell } from '../../atoms/Shell/Shell';
import UserLogoutButtonLink from '../../atoms/UserLogoutButtonLink';
import UserProfileButtonLink from '../../atoms/UserProfileButtonLink';
import '../../../utils/theme/ThemeStyle.css';
import RealTimeline from '../RealTimeline';

const { SubMenu }: any = Menu;
const { Header } = Layout;

const HeaderComponent = () => {
  const { theme } = useTheme();

  const { notificationsFiltered, routes, userName } = useHeader();

  return (
    <S.HeaderWrapper>
      <Header
        style={{
          backgroundColor: '#fff',
          border: 'none',
          boxShadow:
            '0 0.46875rem 2.1875rem rgba(8, 10, 37, 0.03), 0 0.9375rem 1.40625rem rgba(8, 10, 37, 0.03), 0 0.25rem 0.53125rem rgba(8, 10, 37, 0.05), 0 0.125rem 0.1875rem rgba(8, 10, 37, 0.03)',
        }}
      >
        {isIntelbrasTenant() ? (
          <S.IntelbrasLogoWrapper>
            <Link to='/'>
              {theme ? (
                <img
                  src={`https://storage.googleapis.com/mk-move-repository/white-label/${theme}/images/dash-logo.png`}
                  className={`${theme}-logo-header`}
                />
              ) : (
                <Shell height={25} width={100} />
              )}

              {theme == 'celesc' && (
                <>
                  <img
                    src={`https://storage.googleapis.com/mk-move-repository/white-label/${theme}/images/dash-logo2.png`}
                    className={`${theme}-logo2-header`}
                  />
                  <img
                    src={`https://storage.googleapis.com/mk-move-repository/white-label/${theme}/images/dash-logo3.png`}
                    className={`${theme}-logo3-header`}
                  />
                </>
              )}

              <span>{isProUser() ? getProName() : getLiteName()}</span>
            </Link>
          </S.IntelbrasLogoWrapper>
        ) : (
          <S.LogoWrapper>
            <Link to='/'>
              {theme ? (
                <img
                  src={`https://storage.googleapis.com/mk-move-repository/white-label/${theme}/images/dash-logo.png`}
                  className={`${theme}-logo-header`}
                />
              ) : (
                <Shell height={25} width={100} />
              )}

              {theme == 'celesc' && (
                <>
                  <img
                    src={`https://storage.googleapis.com/mk-move-repository/white-label/${theme}/images/dash-logo2.png`}
                    className={`${theme}-logo2-header`}
                  />
                  <img
                    src={`https://storage.googleapis.com/mk-move-repository/white-label/${theme}/images/dash-logo3.png`}
                    className={`${theme}-logo3-header`}
                  />
                </>
              )}
            </Link>
          </S.LogoWrapper>
        )}

        <Menu
          style={{ backgroundColor: '#fff', border: 'none' }}
          theme='light'
          mode='horizontal'
        >
          {routes.map(
            ({ title, path, isMenuHeaderItem }, index) =>
              isMenuHeaderItem && (
                <Menu.Item key={index}>
                  <NavLink to={path}>
                    <S.StyledNavLink>{title}</S.StyledNavLink>
                  </NavLink>
                </Menu.Item>
              ),
          )}

          <SubMenu key='notifications' icon={<NotificationOutlined />}>
            {notificationsFiltered?.length > 0 ? (
              <RealTimeline
                className='realtime'
                width={'unset'}
                padding={'10px 20px 20px 10px'}
                mr={'0'}
                items={parseNotificationsTimeline(notificationsFiltered)}
              />
            ) : (
              <Skeleton active />
            )}
          </SubMenu>

          <SubMenu key='SubMenu' icon={<SettingOutlined />} title={userName}>
            <Menu.Item key='setting:3'>
              <UserProfileButtonLink />
            </Menu.Item>
            <Menu.Item key='setting:4'>
              <UserLogoutButtonLink />
            </Menu.Item>
          </SubMenu>
        </Menu>
      </Header>
    </S.HeaderWrapper>
  );
};

export default HeaderComponent;
